import { Button, Spin } from 'antd';
import style from './SearchStyle';
import SearchPageSpecialType from './SearchPageSpecialType';
import SearchPageItem, { SearchPageItemSelectionProvider } from './SearchPageItem';
import Empty from 'components/Empty';
import { useTranslate } from '@tolgee/react';

type SearchPageProps = {
  searchAllResult: Conversation.SearchMsgAllRtn;
  setShowingTab: (key: string) => void;
  type: string;
  searchWord: string;
  isBatchSearch?: boolean;
  time: number;
  productIds?: Conversation.SearchProdcutIds[];
  loading?: boolean;
  prefetchConversationsMap: Record<string, Conversation.Conversation>;
  onPrefetchConversations: (conversationIds: string[]) => Promise<void>;
};

export default function SearchPage({
  type,
  searchAllResult,
  setShowingTab,
  searchWord,
  isBatchSearch,
  time,
  loading,
  prefetchConversationsMap,
  onPrefetchConversations,
}: SearchPageProps) {
  const { t } = useTranslate();

  if (type !== 'all') {
    return (
      <SearchPageSpecialType
        key={type}
        time={time}
        type={type}
        searchReturn={searchAllResult[type as Conversation.LocalSearchType]}
        searchWord={searchWord}
        isBatchSearch={isBatchSearch}
        prefetchConversationsMap={prefetchConversationsMap}
        onPrefetchConversations={onPrefetchConversations}
      />
    );
  }

  const searchAll = (type: Conversation.LocalSearchType) => {
    return searchAllResult[type] ? (
      <div className={style.allTypeWrap} key={type}>
        <div className={style.typeBar}>{type === 'track' ? t('物流单号') : t(`tab.${type}`)}</div>
        {searchAllResult[type]?.rows?.slice(0, 2).map?.((r) => (
          <SearchPageItem key={r.id} type={type} r={r} />
        ))}
        {searchAllResult[type]?.offsetNum > 0 && (
          <Button type="link" className={style.lookmore} onClick={() => setShowingTab(type)}>
            {t(`lookMore.${type}`)}
          </Button>
        )}
      </div>
    ) : null;
  };

  const searchAllUI = () => {
    const hasResult = Object.values(searchAllResult).some((v) => v.offsetNum >= 0);
    if (hasResult) {
      const types = [];
      if (searchAllResult.buyer?.offsetNum >= 0) {
        types.push('buyer');
      }
      if (searchAllResult.product?.offsetNum >= 0) {
        types.push('product');
      }
      if (searchAllResult.order?.offsetNum >= 0) {
        types.push('order');
      }
      if (searchAllResult['track']?.offsetNum >= 0) {
        types.push('track');
      }
      if (searchAllResult.text?.offsetNum >= 0) {
        types.push('text');
      }
      return types.map((t) => searchAll(t as Conversation.LocalSearchType));
    }
    return <Empty description={t('scene.chatWorkspace.conversationList.empty.noMatchedResult')} />;
  };

  return (
    <div className={style.listWrap}>
      <Spin spinning={loading}>
        <SearchPageItemSelectionProvider prefetchConversationsMap={prefetchConversationsMap}>
          <div className={style.listWrapAll}>{searchAllUI()}</div>
        </SearchPageItemSelectionProvider>
      </Spin>
    </div>
  );
}
